import React from 'react';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function SimpleDropdown(props) {
  return (
    <FormControl
      fullWidth={props.fullWidth || true}
      className={props.className}
      variant={props._variant ? props._variant : 'filled'}
      size={props.size}
    >
      <InputLabel id={props.id}>{props.label}</InputLabel>
      <Select
        labelId={props.id}
        id={props.id}
        value={props.value}
        disabled={props.disabled}
        fullWidth={props.fullWidth || true}
        label={props.label}
        onChange={props.onChange}
        MenuProps={{
          style: {
            zIndex: 99999,
          },
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
      >
        {props.loadingOptions && (
          <MenuItem disabled>
            {props.loadingText ? props.loadingText : 'Loading options...'} &nbsp; <CircularProgress size={18} />
          </MenuItem>
        )}
        {props.addNone ? (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        ) : null}
        {(props.options || []).map((option, indexKey) => (
          <MenuItem key={indexKey + option.value} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
